var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{staticClass:"black",attrs:{"src":require("../assets/block.png")},on:{"click":_vm.black}}),_c('img',{staticClass:"weiitLogo",attrs:{"src":require("../assets/weiit_logo.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }